import { Typography } from '@/components/common';
import { InputCheck, InputText } from '@/components/form';
import { QuestionType } from '@/interfaces';
import clsx from 'clsx';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { FollowUpAnswer } from './DocumentFilterPanel';
import { PurpleRadio } from './PurpelRadio';

/** A single selectable answer row */
export const AnswerRow: React.FC<{
	answer: FollowUpAnswer;
	selected: boolean;
	questionType: QuestionType;
	questionIndex: number;
	onToggle: () => void;
}> = ({ answer, selected, questionType, questionIndex, onToggle }) => {
	const { register } = useForm();
	const isDateType = questionType === 'DATE';
	const isMultipleType = questionType === 'MULTIPLE';

	return (
		<button
			type="button"
			onClick={onToggle}
			className={clsx(
				'w-full flex items-center justify-between rounded-lg transition-colors duration-150',
				isDateType ? 'mt-8' : 'border px-4 py-3 text-left',
				selected && !isDateType
					? 'border-primary bg-[#8039DF0D]'
					: !isDateType
					? 'border-grey-100 bg-white hover:border-primary'
					: ''
			)}
		>
			<div
				className={clsx('flex gap-3', {
					'items-center': questionType === 'YES_NO' || isDateType,
					'items-end': isMultipleType,
				})}
			>
				{!isDateType && (
					<InputCheck
						name={`check-${questionIndex}-${answer.id}`}
						register={register}
						disabled
						defaultChecked={!!answer.isCorrect}
						className="opacity-50"
					/>
				)}

				{isDateType ? (
					<span className="rounded-full w-96 text-lg text-opacity-black bg-grey-5 border-opacity-primary border px-4 py-3 text-left">
						{answer.text}
					</span>
				) : isMultipleType ? (
					<div className="w-full">
						<Typography type="regular-16">
							Option {questionIndex + 1}
						</Typography>
						<div className="grid grid-cols-2 gap-x-2 w-full mt-2">
							<InputText
								name={`anwser-${questionIndex}-${answer.id}`}
								register={register}
								placeholder={answer.text}
								disabled
							/>
							<InputText
								name="details"
								register={register}
								placeholder={answer.detail || 'Optional: Add details'}
								disabled
							/>
						</div>
					</div>
				) : (
					<Typography
						type="regular-16"
						className={clsx(
							selected ? 'text-black font-medium' : 'text-opacity-black'
						)}
					>
						{answer.text}
					</Typography>
				)}
			</div>
			<PurpleRadio selected={selected} />
		</button>
	);
};
